<template>
  <div class="product-status" :class="[cssClasses, statusClass, sizeClass]">
    <span class="product-status__icon"></span>

    <template v-if="text">
      {{ text }}
    </template>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    statusClass() {
      return `product-status--${this.status}`
    },
    sizeClass() {
      return `product-status--${this.size}`
    }
  }
}
</script>

<style lang="scss">
.product-status {
  @include caption;
  display: flex;
  align-items: center;
}

.product-variants .product-status {
  padding: measure(quarter);
}

.product-status__icon {
  flex-shrink: 0;
  margin-right: measure(eighth);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.product-status--in-stock {
  color: color(text-green);
}

.product-status--few-stock {
  color: color(background-warning);
}

.product-status--no-stock {
  color: color(background-signal);
}

.product-status--is-order-item {
  color: color(text-gray-light);
}

.product-status--in-stock .product-status__icon {
  background-image: url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M47.654 30.041c.36-1.623.552-3.31.552-5.041 0-1.797-.205-3.546-.592-5.226l2.336-1.359a25.856 25.856 0 0 0-2.755-6.576l-2.618.715a23.292 23.292 0 0 0-7.287-7.207l.699-2.643A25.416 25.416 0 0 0 31.394 0L30.03 2.386a23.282 23.282 0 0 0-5.004-.543c-1.796 0-3.545.204-5.224.59L18.415.049A26.17 26.17 0 0 0 11.842 2.8l.729 2.668a23.288 23.288 0 0 0-7.2 7.256l-2.67-.706A26.103 26.103 0 0 0 0 18.613l2.396 1.368A23.202 23.202 0 0 0 1.848 25c0 1.791.204 3.535.589 5.209L.053 31.595a26.114 26.114 0 0 0 2.756 6.573l2.664-.728a23.29 23.29 0 0 0 7.26 7.194l-.705 2.668A25.382 25.382 0 0 0 18.625 50l1.366-2.392c1.622.358 3.307.55 5.036.55 1.784 0 3.521-.203 5.19-.584l1.38 2.37a25.917 25.917 0 0 0 6.574-2.756l-.72-2.636a23.291 23.291 0 0 0 7.226-7.266l2.621.693A25.444 25.444 0 0 0 50 31.38l-2.346-1.339z' fill='%2332B168'/%3E%3Cpath d='M21.034 38.39L10 27.842l3.3-3.424 7.27 6.95L36.279 11.8 40 14.764z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E");
}

.product-status--few-stock .product-status__icon {
  background-image: url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M47.654 30.041c.36-1.623.552-3.31.552-5.041 0-1.797-.205-3.546-.592-5.226l2.336-1.359a25.856 25.856 0 0 0-2.755-6.576l-2.618.715a23.292 23.292 0 0 0-7.287-7.207l.699-2.643A25.416 25.416 0 0 0 31.394 0L30.03 2.386a23.282 23.282 0 0 0-5.004-.543c-1.796 0-3.545.204-5.224.59L18.415.049A26.17 26.17 0 0 0 11.842 2.8l.729 2.668a23.288 23.288 0 0 0-7.2 7.256l-2.67-.706A26.103 26.103 0 0 0 0 18.613l2.396 1.368A23.202 23.202 0 0 0 1.848 25c0 1.791.204 3.535.589 5.209L.053 31.595a26.114 26.114 0 0 0 2.756 6.573l2.664-.728a23.29 23.29 0 0 0 7.26 7.194l-.705 2.668A25.382 25.382 0 0 0 18.625 50l1.366-2.392c1.622.358 3.307.55 5.036.55 1.784 0 3.521-.203 5.19-.584l1.38 2.37a25.917 25.917 0 0 0 6.574-2.756l-.72-2.636a23.291 23.291 0 0 0 7.226-7.266l2.621.693A25.444 25.444 0 0 0 50 31.38l-2.346-1.339z' fill='%23E9A638'/%3E%3Cpath fill='%23FFF' d='M23.154 34.65L15 26.856l2.438-2.53 5.373 5.136L34.421 15l2.75 2.19z'/%3E%3C/g%3E%3C/svg%3E");
}

.product-status--no-stock .product-status__icon {
  background-image: url("data:image/svg+xml,%3Csvg width='49' height='50' viewBox='0 0 49 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M46.71 29.474c.353-1.593.54-3.247.54-4.946 0-1.763-.2-3.48-.58-5.127l2.29-1.334a25.38 25.38 0 00-2.7-6.452l-2.567.702a22.84 22.84 0 00-7.142-7.07l.685-2.595A24.898 24.898 0 0030.77 0l-1.335 2.34a22.8 22.8 0 00-4.905-.532c-1.761 0-3.475.2-5.121.58L18.05.048a25.638 25.638 0 00-6.443 2.7l.714 2.617a22.838 22.838 0 00-7.057 7.12l-2.617-.694A25.623 25.623 0 000 18.26l2.348 1.342a22.785 22.785 0 00-.537 4.925c0 1.757.2 3.468.577 5.11l-2.336 1.36a25.634 25.634 0 002.7 6.45l2.613-.715a22.839 22.839 0 007.116 7.058l-.691 2.617a24.866 24.866 0 006.466 2.648l1.339-2.348c1.59.352 3.24.54 4.936.54a22.79 22.79 0 005.086-.573l1.353 2.327a25.39 25.39 0 006.445-2.705l-.706-2.586a22.84 22.84 0 007.082-7.13l2.57.68a24.977 24.977 0 002.648-6.474l-2.3-1.313z' fill='%23B14932'/%3E%3Cpath d='M26.973 29.227h-4.681l-.723-16.482h6.127l-.723 16.482zm-5.404 4.624c0-.86.255-1.53.766-2.007.51-.478 1.252-.717 2.226-.717.965 0 1.695.24 2.192.717.496.477.745 1.146.745 2.007 0 .85-.258 1.515-.774 1.993-.515.477-1.236.716-2.163.716-.936 0-1.669-.239-2.198-.716-.53-.478-.794-1.142-.794-1.993z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E");
}

.product-status--is-order-item .product-status__icon {
  background-image: url("data:image/svg+xml,%3Csvg width='49' height='50' viewBox='0 0 49 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M46.71 29.474c.353-1.593.54-3.247.54-4.946 0-1.763-.2-3.48-.58-5.127l2.29-1.334a25.38 25.38 0 00-2.7-6.452l-2.567.702a22.84 22.84 0 00-7.142-7.07l.685-2.595A24.898 24.898 0 0030.77 0l-1.335 2.34a22.8 22.8 0 00-4.905-.532c-1.761 0-3.475.2-5.121.58L18.05.048a25.638 25.638 0 00-6.443 2.7l.714 2.617a22.838 22.838 0 00-7.057 7.12l-2.617-.694A25.623 25.623 0 000 18.26l2.348 1.342a22.785 22.785 0 00-.537 4.925c0 1.757.2 3.468.577 5.11l-2.336 1.36a25.634 25.634 0 002.7 6.45l2.613-.715a22.839 22.839 0 007.116 7.058l-.691 2.617a24.866 24.866 0 006.466 2.648l1.339-2.348c1.59.352 3.24.54 4.936.54a22.79 22.79 0 005.086-.573l1.353 2.327a25.39 25.39 0 006.445-2.705l-.706-2.586a22.84 22.84 0 007.082-7.13l2.57.68a24.977 24.977 0 002.648-6.474l-2.3-1.313z' fill='%23757272'/%3E%3Cpath d='M26.973 29.227h-4.681l-.723-16.482h6.127l-.723 16.482zm-5.404 4.624c0-.86.255-1.53.766-2.007.51-.478 1.252-.717 2.226-.717.965 0 1.695.24 2.192.717.496.477.745 1.146.745 2.007 0 .85-.258 1.515-.774 1.993-.515.477-1.236.716-2.163.716-.936 0-1.669-.239-2.198-.716-.53-.478-.794-1.142-.794-1.993z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E");
}

.product-status--small {
  @include caption;
}

.product-status--medium {
  @include body-smaller;
}

.product-status--large {
  @include body;
}

.product-status--small .product-status__icon {
  width: 1.125rem;
  height: 1.125rem;
}

.product-status--medium .product-status__icon {
  width: 1.375rem;
  height: 1.375rem;
}

.product-status--large .product-status__icon {
  width: 1.875rem;
  height: 1.875rem;
  margin-right: measure(quarter);
}
</style>
